import { isJobHasContractorPropertyGroupType } from '@models';
import { connect } from 'react-redux';

import ContractorProfile from '../components/ContractorProfile';
import type { ApplicationState } from '../store';
import * as ContractorStore from '../store/contractors';
import * as UserStore from '../store/user';

export default connect(
    (state: ApplicationState) => ({
        constants: state.constants,
        workId: state.user?.work?.id,
        propertyGroupTypes: state.user.propertyGroupTypes.filter(isJobHasContractorPropertyGroupType),
        user: state.identity?.user,
        ...UserStore.plainActions,
        ...ContractorStore.plainActions,
        moduleManager: state.modules.moduleManager,
    }),
    {},
)(ContractorProfile as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
